var login = {
  translation: {
    common: {
      accept: '接受',
      alreadyUser: '已经是用户？',
      and: '和',
      backToLogin: '返回登录页面',
      continueWith: '使用 {{provider}} 继续',
      createAccount: '创建账户',
      createYourAccount: '创建你的账户',
      emailOrUsername: '邮箱或用户名',
      login: '登录',
      logInToBoards: '登录',
      newToBoards: '刚来到 4ga Boards?',
      pageNotFound_title: '页面未找到',
      password: '密码',
      privacyPolicy: '隐私政策',
      register: '注册',
      registerWithGoogle: '使用 Google 注册',
      termsOfService: '服务条款',
      togglePasswordVisibility: '切换密码可见性',
    },

    action: {
      logIn: '登录',
    },
  },
};

export { login as default };
